import { Navigate, Outlet } from 'react-router-dom';
import { FullScreenLoader } from '@/components/common/FullScreenLoader';
import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';
import { useAuth } from '@/hooks/useAuth';

export function RequireAuthenticatedSession() {
  const { status } = useAuth();

  if (status === 'loading') {
    return <FullScreenLoader />;
  }
  if (status === 'unauthenticated') {
    return <Navigate to={APPLICATION_ROUTES.login} replace />;
  }
  return <Outlet />;
}
